import { Component, type ErrorInfo, type ReactNode } from "react";

// ============================================================
// Error Boundary — Catches unhandled React render errors
// ============================================================

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("ErrorBoundary caught:", error, info.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex h-full items-center justify-center p-8">
					<div className="max-w-md text-center space-y-4">
						<div className="text-4xl">!</div>
						<h1 className="font-display text-xl text-stone-800">
							Etwas ist schiefgelaufen
						</h1>
						<p className="text-sm text-stone-500">
							{this.state.error?.message ?? "Unbekannter Fehler"}
						</p>
						<button
							type="button"
							onClick={() => {
								this.setState({ hasError: false, error: null });
								window.location.href = "/";
							}}
							className="btn-primary text-sm"
						>
							Zurück zum Dashboard
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
